import { createStore } from "vuex";

export default createStore({
  state: {
    activePage: '',
    scrollToRegisterSection: false,
    scrollToAppointmentSection: false,
    scrollToServicesSection: '',
    scrollToRegisterOnAfspraak: false,
    members: [{ 
      id: 'milad-rahatianpur',
      name: 'Milad Rahatianpur',
      function: 'Tandarts', 
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      image: 'Miladnieuw.jpg'
    },
    { 
      id: 'ali-al-saady',
      name: 'Ali Al-Saady',
      function: 'Tandarts',
      motivation: '"Motivatie Ali Al-Saady."',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      image: 'ali-al-saady.jpg'
    },
    { 
      id: 'collega-milad',
      name: 'Collega Milad',
      function: 'Tandarts',
      motivation: '"Motivatie Collega Milad."',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      image: 'milad-rahatianpur.jpg'
    },
  ]
  },
  mutations: {
    updateActivePage (state, page) {
      state.activePage = page
    },
    updateScrollToRegister (state, scrolltoregister) {
      state.scrollToRegisterSection = scrolltoregister
    },
    updateScrollToAppointment (state, scrolltoappointment) {
      state.scrollToAppointmentSection = scrolltoappointment
    },
    updateScrollToServices (state, scrolltoservices) {
      state.scrollToServicesSection = scrolltoservices
    },
    updateScrollToRegisterOnAfspraak (state, scroll) {
      state.scrollToRegisterOnAfspraak = scroll
    },
  },
  actions: {},
  modules: {},
});
